module.exports = __webpack_public_path__ + "img/forge_block.c3b8d010.jpg";